@if (useAuthLayout) {
  <div class="auth-container min-vh-100">
    <div class="auth-card">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
